module.exports = "/images/vendor/flag-icon-css/flags/1x1/co.svg?41244c207c1c8c92c0140d5fad3b08b1";